import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";

export default function QuickReplies({ options, onSelect }) {
  if (!options || options.length === 0) return null;

  return (
    <div className="mt-4 flex flex-col items-start gap-2">
      {options.map((option, index) => (
        <motion.button
          key={index}
          onClick={() => onSelect(option)}
          whileHover={{ scale: 1.05, y: -2 }}
          whileTap={{ scale: 0.95 }}
          initial={{ opacity: 0, y: 15 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: index * 0.08 }}
         className="group self-start inline-flex items-center gap-2 rounded-full border border-violet-500/30 bg-white/5 px-3 py-1.5 text-xs font-medium text-white backdrop-blur-xl transition-all duration-300 hover:border-fuchsia-500 hover:bg-gradient-to-r hover:from-violet-600 hover:to-fuchsia-600 hover:shadow-[0_10px_25px_rgba(168,85,247,0.35)]"
        >
          {option.icon && (
            <span className="text-violet-300 group-hover:text-white">
              {option.icon}
            </span>
          )}

          <span>{option.label}</span>

          <ArrowRight
            size={15}
            className="opacity-60 transition-transform duration-300 group-hover:translate-x-1 group-hover:opacity-100"
          />
        </motion.button>
      ))}
    </div>
  );
}